module.exports = __webpack_public_path__ + "img/Cover_FS_22.60d36da9.jpg";